// extracted by mini-css-extract-plugin
export default {"root":"SnakeLayout-module-root-GCtm4"};